import { Injectable } from '@angular/core';
import { Country } from '../../models/Country'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Observable } from 'rxjs'
import serviceConfig from '../service-config';
import { IndustryType } from '../../models/IndustryType'
import { PersonTitle } from '../../models/personTitle'
import { AppState } from '../../core/reducers/index';
import { selectAuthState } from '../../core/auth/_selectors/auth.selectors';
import { Store } from '@ngrx/store';
import * as jwt_decode from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  uri = serviceConfig.altBaseUrl;
  uriLogisticW = serviceConfig.logisticWarehouseBaseUrl;
  fileHeaders: HttpHeaders
  headers: HttpHeaders;
  userId: '';
  
  constructor(private http: HttpClient, private store: Store<AppState>) {
    this.store.select(selectAuthState).subscribe((result) => {
      this.fileHeaders = new HttpHeaders()
      .append('Authorization', "Bearer " + result.authToken)
      .append('Access-Control-Allow-Headers', 'Origin, X-Requested-With, Content-Type, Accept, Referer, User-Agent')
      
      var decoded = jwt_decode(result.authToken);
      this.userId = decoded['https://mardom.com/clientId'];
      this.headers = new HttpHeaders()
        .append('Authorization', "Bearer " + result.authToken)
        .append('Content-Type', 'application/json')
        .append('accept', '*/*')
        .append('Allow', '*')
        .append('Access-Control-Allow-Origin', '*')
        .append('Access-Control-Allow-Methods', 'POST, GET, PUT, DELETE, OPTIONS')
        .append('Access-Control-Allow-Headers', 'Origin, X-Requested-With, Content-Type, Accept, Referer, User-Agent')
        .append('accept', 'text/plain');
    })
  }

  getCountries(): Observable<Country[]> {
    return this.http.get<Country[]>(
      this.uri + serviceConfig.endPoints.country
    )
  }

  verifyRNC(no): Observable<Country[]> {
    return this.http.get<Country[]>(
      //'https://api.digital.gob.do/v1/contributors/' + no + '/info/basic'
      'https://marmgorncapi-g0ephfcvcvftaug4.eastus2-01.azurewebsites.net/GetRNC?rnc=' + no
    )
  }

  sendEmail(email) {
    //const  url = this.uri + '/logistic-warehouse/Home/SendAuthEmail?emailId=' + email //FOR PROD ENV
    const url = `${this.uriLogisticW}/Home/SendAuthEmail?emailId=${email}` //FOR UAT ENV

    return this.http.get<any[]>(url)
  }

  sendSuccessfullRegistrationEmail(payload) {
    // const url = this.uri + '/logistic-warehouse/Home/SendSuccessfullRegistrationEmail?email='+payload.email +'&username=' + payload.name
    // +'&emailAccount=' + payload.emailAccount+'&companyName=' + payload.companyName; //FOR PROD ENV

    const url =`${this.uriLogisticW}/Home/SendSuccessfullRegistrationEmail?email=${payload.email}&username=${payload.name}
    &emailAccount=${payload.emailAccount}&companyName=${payload.companyName}`; //FOR UAT ENV

    return this.http.get<any[]>(url)
  }

  checkEmailExit(email) {
    //const url = this.uri + '/logistic-warehouse/Home/ValidateEmail?EmailId=' + email; //FOR PROD ENV
    const url =  `${this.uriLogisticW}/Home/ValidateEmail?EmailId=${email}`; //FOR UAT ENV
    //const url = `https://localhost:44381/Home/ValidateEmail?EmailId=${email}`; //FOR LOCAL ENV

    return this.http.get<any[]>(`${url}`, { headers: this.headers })
  }

  //**********Country* */
  getIndustryTypes(): Observable<IndustryType[]> {
    return this.http.get<IndustryType[]>(
      this.uri + serviceConfig.endPoints.industryType
    )
  }

  //**person */
  getPersonTitle(): Observable<PersonTitle[]> {
    return this.http.get<PersonTitle[]>(
      this.uri + serviceConfig.endPoints.personTitle
    )
  }

  loginApi(email,pass){
    return this.http.get<any>(
      this.uri + serviceConfig.endPoints.loginurl +'?username='+email+'&password='+pass
    )
  }

}
